'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "dashboard-details-panel" */
'./DashboardDetailsPanel');
export default Loadable({
  loader,
  LoadingComponent: () => null
});